import React, { useContext } from "react";
import { AppContext } from "./AppContext";
import { Filters } from "./Filters";
import { VenueCard } from "./VenueCard";

export const VenueTab: React.FC = () => {
  const { filteredVenues } = useContext(AppContext);

  return (
    <>
      <div className="venue-scroll flex-grow h-full scrolling-touch overflow-y-auto overflow-x-hidden">
        {filteredVenues.map((venue, i) => (
          <VenueCard key={venue.properties._path} venue={venue} />
        ))}
        {filteredVenues.length === 0 && (
          <div className="p-4">
            <h2 className="font-bold text-xl">No venues found</h2>
            <p>
              We couldn't find any venues which matched your filter criteria.
              Please refine your filter and try again.
            </p>
          </div>
        )}
      </div>
    </>
  );
};
